<div class="swag-migration-wizard swag-migration-wizard-page-credentials">
    {% block swag_migration_wizard_page_credentials_content %}
            {% block swag_migration_wizard_page_credentials_information %}
                <div class="swag-migration-wizard__content-information">
                    <h3 class="swag-migration-wizard__information-header">
                        {{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.title') }}
                    </h3>
                    <ol class="swag-migration-wizard-page-credentials__steps">
                        <li>
                            <i18n-t
                                keypath="swag-migration.wizard.pages.credentials.shopware6.api.steps.step1"
                                tag="span"
                                scope="local"
                            >
                                <template #pluginName>
                                    {{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.pluginName') }}
                                </template>
                            </i18n-t>

                            <mt-link
                                as="a"
                                :to="$tc('swag-migration.wizard.pages.credentials.shopware6.api.pluginLink')"
                                target="_blank"
                                type="external"
                            >
                                {{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.pluginLinkText') }}
                            </mt-link>
                        </li>

                        <li>
                            <span>
                                {{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.steps.step2') }}
                            </span>

                            <mt-link
                                as="a"
                                :to="$tc('swag-migration.wizard.pages.credentials.shopware6.api.integrationLink')"
                                target="_blank"
                                type="external"
                            >
                                {{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.integrationLinkText') }}
                            </mt-link>
                        </li>

                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.steps.step3') }}</li>
                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware6.api.steps.step4') }}</li>
                    </ol>
                </div>
            {% endblock %}

            {% block swag_migration_wizard_page_credentials_credentials %}
                <div class="swag-migration-wizard__form">
                    {% block swag_migration_wizard_page_credentials_apiuser_field %}
                        <mt-text-field
                            v-model:model-value="inputCredentials.apiUser"
                            v-autofocus
                            name="sw-field--apiUser"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware6.api.apiUserLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware6.api.apiUserPlaceholder')"
                            :help-text="$tc('swag-migration.wizard.pages.credentials.shopware6.api.apiUserTooltip')"
                            validation="required"
                            required
                        >

                            {% block swag_migration_wizard_page_credentials_apiuser_icon %}
                                <template #suffix>
                                    <mt-icon name="regular-user" />
                                </template>
                            {% endblock %}
                        </mt-text-field>
                    {% endblock %}

                    {% block swag_migration_wizard_page_credentials_apiPassword_field %}
                        <mt-password-field
                            v-model:model-value="inputCredentials.apiPassword"
                            name="sw-field--apiPassword"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware6.api.apiPasswordLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware6.api.apiPasswordPlaceholder')"
                            :help-text="$tc('swag-migration.wizard.pages.credentials.shopware6.api.apiPasswordTooltip')"
                            validation="required"
                            required
                        />
                    {% endblock %}

                    {% block swag_migration_wizard_page_credentials_endpoint_field %}
                        <mt-url-field
                            v-model:model-value="inputCredentials.endpoint"
                            :validation="inputCredentials.endpoint !== 'http://' && inputCredentials.endpoint !== 'https://'"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware6.api.endpointLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware6.api.endpointPlaceholder')"
                            :switch-label="$tc('swag-migration.wizard.pages.credentials.shopware6.api.endpointSSLLabel')"
                            required
                        />
                    {% endblock %}
                </div>
            {% endblock %}
    {% endblock %}
</div>
